
if (!customElements.get("bundle-builder-activator")) {
  customElements.define(
    "bundle-builder-activator",
    class BundleBuilderActivator extends HTMLElement {

      constructor() {
        super();
        this.activator = this.querySelectorAll("[data-bundle-builder-activate]")
        this.mainProduct = document.getElementById("main-product");
        this.bundleBuilder = document.querySelector("bundle-builder");
        this.announcementBar = document.querySelector(".s-announcements");
      }

      connectedCallback() {

        this.activator.forEach(el => el.addEventListener("click", () => this.handleToggle()));

        // Add close button event listener
        const closeBtn = this.bundleBuilder?.querySelector('[data-bundle-builder-close]');
        if (closeBtn) {
          closeBtn.addEventListener("click", () => this.handleClose());
        }

        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get("bundle-builder") === "show") {
          this.handleToggle();
        }
      }

      handleToggle() {

        this.mainProduct.classList.add("hidden");
        this.bundleBuilder.classList.remove("hidden");
        scrollToElement(".bg-chirp-gray-neutral.shrink-0");
        document.body.style.overflow = 'hidden';
        this.announcementBar?.classList.add('hidden');
      }

      handleClose() {
        this.mainProduct.classList.remove("hidden");
        this.bundleBuilder.classList.add("hidden");
        document.body.style.overflow = '';
        this.announcementBar?.classList.remove('hidden');
      }

      // Expose close method globally for external access
      close() {
        this.handleClose();
      }

      disconnectedCallback() {
        this.activator.removeEventListener("click", () => this.handleToggle());
        document.body.style.overflow = '';
      }
    }
  );
}


if (!customElements.get("bundle-builder")) {
    customElements.define(
      "bundle-builder",
      class BundleBuilder extends HTMLElement {

        constructor() {
          super();
          this.primarySlots = parseInt(this.dataset.primarySlots);
          this.minOptionalSlots = 1; // At least one optional slot required
          this.maxOptionalSlots = 999; // Allow unlimited optional slots for visual display
          this.optionalSlots = [];
          this.items = [];
          this.selectedOptionalOrder = [];
          this.selectedSellingPlan = null;
          this.hasResetOptionalPrices = false;

          // Get DOM references
          this.slots = this.querySelectorAll("[data-bb-slot]");
          this.optionalSlotsContainer = this.querySelector('[data-bb-optional-slots-container]');
          this.optionalSlotTemplate = document.getElementById('optional-slot-template');          
          this.optionalSlotPlaceholder = this.optionalSlotsContainer.querySelector('[bb-slot-placeholder]');
          this.promoList = this.querySelector('#opt-product-list');
          this.paidList = this.querySelector('#paid-product-list');
          this.sliders = this.querySelectorAll('.swiper.quickViewSlider');
          this.startAttr = this.dataset.promoStart;
          this.endAttr = this.dataset.promoEnd;

          // Button references
          this.addToCartBtn = this.querySelector('[data-bb-add-to-cart]');
          this.removeBtns = this.querySelectorAll("[data-bb-remove]");
          this.addBtns = this.querySelectorAll("[data-bb-add]");
          this.mainProductElements = this.querySelectorAll('[data-bb-main-product]');
          this.addMainProductBtn = this.querySelector('#addMainBundleProduct');
          this.optProductElements = this.querySelectorAll('[data-bb-opt-product]');
          this.addOptProductsBtn = this.querySelector('#addOptBundleProducts');
          this.addPaidProductsBtn = this.querySelector('#addPaidBundleProducts');
          this.quickViewTrigger = this.querySelectorAll('[data-quickview-trigger]');
        }


        connectedCallback() {
          this.setupEventListeners();
          this.autoAddHaloDouble();
          // this.initializeOptionalSlots();
          this.updateUI();
          this.setupSliders(this.sliders);
          this.updateDiscountBanners();
          this.setupDraggableScroll();

        if (this.usesHaloPadLogic() && this.optionalSlotPlaceholder) {
          this.optionalSlotPlaceholder.classList.add('hidden');
          if (this.isInPromoRange()) {
            const firstOptionalItem = this.items[this.primarySlots];
            if (!firstOptionalItem) {
              this.removeOptionalSlot(0);
            }
            this.ensureFreeSlots();
          }
        }

          // this.setupDesktopCollapse();
          const firstMain = this.querySelector('[data-bb-screen="0"] [data-bb-main-product]');
          if (firstMain) {
            this.populateQuickView(firstMain, 0);
          }

          const firstOpt = this.querySelector('[data-bb-screen="1"] [data-bb-opt-product]');
          if (firstOpt) {
            this.populateQuickView(firstOpt, 1);
          }

          // For mobile confirm
          const confirmMobile = this.querySelector('#confirmSubscriptionPlanMobile');
          if (confirmMobile) {
            confirmMobile.addEventListener('click', () => {
              this.confirmSubscriptionSelection('#subscriptionModal');
            });
          }

          this.updateOptionalProductPrices();
        }


        setupEventListeners() {
          this.addToCartBtn.addEventListener("click", () => this.addToCart());
          this.addBtns.forEach((btn) =>
            btn.addEventListener("click", (e) => this.add(e))
          );
          this.removeBtns.forEach((btn) =>
            btn.addEventListener("click", (e) => this.remove(e))
          );
        
          // Event delegation for optional slot remove buttons
          this.optionalSlotsContainer.addEventListener('click', (e) => {
            const removeBtn = e.target.closest('[data-bb-remove-optional]');
            if (removeBtn) {
              const slot = removeBtn.closest('[data-bb-optional-slot]');
              const indexAttr = slot?.dataset.slotIndex;
              const index = indexAttr ? parseInt(indexAttr, 10) : -1;
          
              if (index >= 0) {
                this.removeOptionalSlot(index);
                if (this.isInPromoRange()) {
                  this.ensureFreeSlots();
                }
              }
            }
          });
        
          this.slots.forEach((slot, idx) => {
            const removeBtn = slot.querySelector('[data-bb-remove]');
            removeBtn?.addEventListener('click', () => {
              this.items.splice(idx, 1);
              this.removeOptionalSlot(0);
              this.updateUI();
            });
          });
        
          this.mainProductElements.forEach(el => {
            el.addEventListener('click', () => this.selectMainProduct(el));
          });
        
          this.addMainProductBtn.addEventListener('click', () => this.handleAddMainProduct());
        
          this.optProductElements.forEach(el => {
            el.addEventListener('click', () => this.toggleOptionalProduct(el));
          });
        
          // This is the key part: attach BOTH the add handler AND the modal open logic
          this.addOptProductsBtn.addEventListener('click', () => {
            this.handleAddOptionalProducts();
            this.updateOptionalProductPrices();
        
            // setTimeout(() => {
            //   this.updateOptThumbs();
              
            //   const modal = this.querySelector('#subscriptionModal');
            //   if (modal && typeof modal.open === 'function') {
            //     modal.open();
            //   }
            // }, 0);
          });

          this.addPaidProductsBtn.addEventListener('click', () => {
            this.handleAddOptionalProducts();
            this.updateOptionalProductPrices();      
          });

          this.quickViewTrigger.forEach(el => {
            el.addEventListener('click', () => this.populateQuickView(el));
          });          
        }

        setupSliders(sliders) {
          sliders.forEach((el) => {
            if (!el.classList.contains('swiper-initialized')) {
              const id = el.className.match(/swiper-(\d+)/)?.[1];
              if (!id) return;
        
              new Swiper(el, {
                loop: true,
                slidesPerView: 1,
                navigation: {
                  nextEl: el.querySelector(`.swiper-button-next-${id}`),
                  prevEl: el.querySelector(`.swiper-button-prev-${id}`),
                },
                grabCursor: true,
              });
            }
          });
        }

        hasEmptyFreeSlot() {
          return this.optionalSlots.some(slot => {
            const span = slot.element.querySelector('span');
            return span?.textContent === 'FREE' && !slot.filled;
          });
        }

        autoAddHaloDouble() {
          // Check if there's only one parent product available
          const parentProducts = this.querySelectorAll('[data-bb-main-product]');
          
          if (parentProducts.length === 1) {
            // Auto-add the single parent product
            const singleProduct = parentProducts[0];
            const addButton = singleProduct.querySelector('[data-bb-add]');
            
            if (addButton) {
              // Get the product data from the button
              const productData = {
                id: addButton.dataset.id,
                title: addButton.dataset.title,
                image: addButton.dataset.image,
                price: addButton.dataset.price,
                subscription_text: 'One-time purchase'
              };
              
              this.items.push(productData);
              
              // Check if we're on halo-bundle template and have an included pad
              const includedPadId = this.dataset.includedPadId;
              if (includedPadId) {
                this.autoAddIncludedPad(includedPadId);
              }
              
              // Calculate how many slots we need
              // If we already added a pad, we need slots for: the pad + empty slots
              const optionalItemsCount = this.items.length - this.primarySlots;
              const desiredEmptySlots = 2;
              const totalSlotsNeeded = optionalItemsCount + desiredEmptySlots;
              
              // Create the necessary slots
              if (this.isInPromoRange()) {
                // Create slots, marking the first two as free if needed
                for (let i = 0; i < totalSlotsNeeded; i++) {
                  const isFree = i < 2;
                  this.addOptionalSlot({ isFree: isFree });
                }
              } else {
                // Create regular slots
                for (let i = 0; i < totalSlotsNeeded; i++) {
                  this.addOptionalSlot();
                }
              }
            }
          } else {
            // Fallback to original Halo Double logic for backward compatibility
            const haloDoubleId = this.querySelector('[data-bb-screen="0"]')?.dataset.haloBundle;
            if (haloDoubleId) {
              const haloDoubledataSet = this.querySelector(`.btn[data-id="${haloDoubleId}"]`)?.dataset;
              if (haloDoubledataSet) {
                this.items.push({
                  id: haloDoubleId,
                  title: haloDoubledataSet.title,
                  image: haloDoubledataSet.image,
                  price: haloDoubledataSet.price,
                  subscription_text: 'One-time purchase'
                });
                
                // Check if we're on halo-bundle template and have an included pad
                const includedPadId = this.dataset.includedPadId;
                if (includedPadId) {
                  this.autoAddIncludedPad(includedPadId);
                }
                
                // Calculate how many slots we need after adding pad (if applicable)
                const optionalItemsCount = this.items.length - this.primarySlots;
                const desiredEmptySlots = 2;
                const totalSlotsNeeded = optionalItemsCount + desiredEmptySlots;
                
                // Ensure we have enough slots
                while (this.optionalSlots.length < totalSlotsNeeded) {
                  this.addOptionalSlot();
                }
              }
            }
          }
        }

        autoAddIncludedPad(padVariantId) {
          // Find the pad product element by variant ID - check both promo and paid lists
          let padElement = this.querySelector(`[data-bb-opt-product="${padVariantId}"]`);
          
          // If not found, try to find it by searching all optional product elements
          if (!padElement) {
            const allOptProducts = this.querySelectorAll('[data-bb-opt-product]');
            for (const el of allOptProducts) {
              if (el.dataset.bbOptProduct === padVariantId) {
                padElement = el;
                break;
              }
            }
          }

          if (!padElement) {
            console.warn(`Could not find pad product with variant ID: ${padVariantId}`);
            return;
          }

          // Get product information from the element
          const padTitle = padElement.querySelector('h3')?.textContent?.trim() || 'Pad';
          const padImage = padElement.querySelector('img')?.src || '';
          const padPriceCents = padElement.dataset.productPrice;
          const padPrice = padPriceCents ? this.formatPrice(padPriceCents) : '$0.00';

          // Try to get variant ID from the add button if available
          const padAddButton = padElement.querySelector('[data-bb-add]');
          const padId = padAddButton?.dataset.id || padVariantId;

          // Create pad product data
          const padData = {
            id: padId,
            title: padTitle,
            image: padImage,
            price: padPrice,
            subscription_text: 'One-time purchase'
          };

          // Add the pad to items
          this.items.push(padData);

          // Update UI will handle creating the slot and displaying the pad
          // No need to manually add optional slot here since updateOptionalSlots will handle it
        }

        formatPrice(priceCents) {
          const price = parseInt(priceCents, 10) / 100;
          return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(price).replace('.00', '');
        }

        isInPromoRange() {
          if (!this.startAttr || !this.endAttr) return false;
        
          const now = new Date();
          const start = new Date(this.startAttr);
          const end = new Date(this.endAttr);
        
          return now >= start && now <= end;
        }

        updateOptionalProductPrices() {
          if (!this.isInPromoRange()) {
            this.showPaidProducts(); // oculta productos promo
            return;
          }

          if (!this.usesHaloPadLogic()) return;
        
          const optionalItems = this.items.slice(this.primarySlots); // only optional items
          const alreadyAdded = optionalItems.length;
          const freeLimit = 2;
          
          const allElements = this.querySelectorAll('[data-bb-opt-product]');
          allElements.forEach(el => {
            const span = el.querySelector('span.font-extrabold');
            if (!span) return;
        
            const originalCents = el.dataset.productPrice;
            const formatted = originalCents
              ? (parseInt(originalCents, 10) / 100).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })
              : '';
        
            // Clear old strikethrough if exists
            const oldStrike = el.querySelector('.bb-strike');
            if (oldStrike) oldStrike.remove();
        
            if (alreadyAdded < freeLimit) {
              // Show $0.00 with strikethrough original price
              span.textContent = '$0.00';
        
              if (formatted) {
                const strike = document.createElement('s');
                strike.textContent = formatted;
                strike.className = 'ml-2 bb-strike text-sm';
                span.parentNode.appendChild(strike);
              }
              this.showPromoProducts();
            } else {
              // Show normal price
              span.textContent = formatted;
              this.showPaidProducts();
            }
          });
        }

        resetOptProductPrices () {
          const allElements = this.querySelectorAll('[data-bb-opt-product]');
          allElements.forEach(el => {
            const span = el.querySelector('span.font-extrabold');
            if (!span) return;

            const oldStrike = el.querySelector('.bb-strike');
            if (oldStrike) oldStrike.remove();

            const originalCents = el.dataset.productPrice;
            const formatted = originalCents
              ? (parseInt(originalCents, 10) / 100).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })
              : '';
            span.textContent = formatted;            
          });
        }
                                     
        showPaidProducts() {          
          this.promoList.classList.add('hidden');
          this.addOptProductsBtn.closest('div').classList.add('hidden');
          // this.querySelector('#toggleOptProducts').classList.add('hidden');

          this.paidList.classList.remove('hidden');
          this.addPaidProductsBtn.closest('div').classList.remove('hidden');
        }

        showPromoProducts() {
          if (!this.promoList.classList.contains('hidden')) return;

          this.paidList.classList.add('hidden');
          this.addPaidProductsBtn.closest('div').classList.add('hidden');

          this.promoList.classList.remove('hidden');
          this.addOptProductsBtn.closest('div').classList.remove('hidden');
          // this.querySelector('#toggleOptProducts').classList.remove('hidden');
        }

        isHaloDouble() {
          return this.items.some(item => item.title.includes('Double'));
        }

        usesHaloPadLogic() {
          const templateSuffix = this.dataset.templateSuffix || '';
          const templateIndicatesHalo = /halo/i.test(templateSuffix);
          return this.isHaloDouble() || this.isHaloBundle() || templateIndicatesHalo;
        }

        populateQuickView(el, forceScreen = null) {
          const handle = el.dataset.productHandle;
        
          if (!handle) return;
        
          // Determine which bb-screen is visible, unless forced
          let activeScreen = null;
        
          if (forceScreen !== null) {
            // Find the screen matching the forced index
            activeScreen = this.querySelector(`[data-bb-screen="${forceScreen}"]`);
          } else {
            const screens = this.querySelectorAll('[data-bb-screen]');
            screens.forEach(screen => {
              if (!screen.classList.contains('hidden')) {
                activeScreen = screen;
              }
            });
          }
        
          if (!activeScreen) return;
        
          // Pick the right container
          let container;
          if (activeScreen.dataset.bbScreen === "0") {
            container = this.querySelector('#product-detail-container-main');
          } else if (activeScreen.dataset.bbScreen === "1") {
            container = this.querySelector('#product-detail-container');
          }
        
          if (!container) return;
        
          // Load content
          const hidden = this.querySelector(`#product-quickview-${handle}`);
          if (hidden) {
            container.innerHTML = hidden.innerHTML;
            const slider = container.querySelectorAll('.swiper.inlineSlider');
            if (slider.length > 0) {
              this.setupSliders(slider);
            }
          } else {
            container.innerHTML = '<div class="p-8 text-center text-red-500">Product details not found.</div>';
          }
        }        

        setupDesktopCollapse() {
          // Only apply on desktop
          const isDesktop = window.innerWidth >= 1024;
          if (!isDesktop) return;
        
          const list = this.querySelector('#opt-product-list');
          const items = list?.querySelectorAll('[data-bb-opt-product]');
          const toggleBtn = this.querySelector('#toggleOptProducts');
        
          if (!list || !items || items.length <= 5 || !toggleBtn) return;
        
          // Initially hide items after the 5th
          items.forEach((el, i) => {
            if (i >= 5) el.classList.add('hidden');
          });
        
          toggleBtn.classList.remove('hidden');
        
          let expanded = false;
        
          toggleBtn.addEventListener('click', () => {
            expanded = !expanded;
        
            items.forEach((el, i) => {
              if (i >= 5) el.classList.toggle('hidden', !expanded);
            });
        
            toggleBtn.textContent = expanded ? 'Show Less' : 'See All Pad Options';
          });
        }        

        confirmSubscriptionSelection(containerSelector) {
          const container = this.querySelector(containerSelector);
          const selectedRadio = container.querySelector('input[name="shared-purchase-type"]:checked');
          if (!selectedRadio) return;
        
          const value = selectedRadio.value;
          let text = 'One-time purchase';
        
          const planMapElement = this.querySelector('#sellingPlanMap');
          if (!planMapElement) {
            console.error("No selling plan map found!");
            return;
          }
          const planMap = JSON.parse(planMapElement.textContent);
        
          const optionalStart = this.primarySlots;
          for (let i = optionalStart; i < this.items.length; i++) {
            const item = this.items[i];
            if (value === 'otp') {
              item.selling_plan = null;
              item.subscription_text = 'One-time purchase';
            } else {
              const variantPlans = planMap[item.id];
              if (variantPlans && variantPlans[value]) {
                item.selling_plan = variantPlans[value];
                item.subscription_text = `Every ${value}`;
              } else {
                console.warn(`No matching selling plan for variant ${item.id} and frequency "${value}"`);
                item.selling_plan = null;
                item.subscription_text = 'One-time purchase';
              }
            }
          }
        
          // Close the modal if it's mobile
          if (containerSelector === '#subscriptionModal') {
            const modal = this.querySelector('#subscriptionModal');
            if (modal && typeof modal.close === 'function') {
              modal.close();
            }
          }
        
          this.updateUI();
        }        

        selectMainProduct(el) {
          this.mainProductElements.forEach(item => {
            item.removeAttribute('selected');
          });
          el.setAttribute('selected', 'selected');
          this.updateOptionalProductPrices();
        }
        
        handleAddMainProduct() {
          const selected = this.querySelector('[data-bb-main-product][selected]');
          if (!selected) {
            alert('Please select a product.');
            return;
          }
          const addButton = selected.querySelector('.hidden[data-bb-add]');

          this.optionalSlotPlaceholder?.classList.add('hidden');

          if (addButton) {
            addButton.click();
          } else {
            console.error('No add button found in selected product.');
          }
        }

        toggleOptionalProduct(el) {
          this.optProductElements.forEach(opt => {
            opt.removeAttribute('selected');
            opt.classList.replace('bg-chirp-gray', 'bg-chirp-gray-lighter');
          });
          el.setAttribute('selected', 'selected');
          el.classList.replace('bg-chirp-gray-lighter', 'bg-chirp-gray');
        }     

        handleAddOptionalProducts() {
          const selectedElement = this.querySelector('[data-bb-opt-product][selected]');
          if (!selectedElement) {
            alert('Please select at least one optional product.');
            return;
          }

          const addButton = selectedElement.querySelector('[data-bb-add]');
          if (addButton) addButton.click();

          // Reset selection
          selectedElement.removeAttribute('selected');
          selectedElement.classList.replace('bg-chirp-gray', 'bg-chirp-gray-lighter');
        }                                  

        initializeOptionalSlots() {
        if (this.usesHaloPadLogic() && this.isInPromoRange()) {
            this.ensureFreeSlots();
          } else {
            this.addOptionalSlot();
          }
        }

        ensureFreeSlots() {
        if (!this.usesHaloPadLogic()) return;
        
          const filledFreeItems = this.items.slice(this.primarySlots);
          const currentFreeSlots = this.optionalSlots.filter(slot => {
            const span = slot.element.querySelector('span');
            return span?.textContent === 'FREE';
          });
        
          const emptyFreeSlots = currentFreeSlots.filter(slot => !slot.filled);
        
          const totalFreeNeeded = 2 - filledFreeItems.length - emptyFreeSlots.length;
          const slotsToAdd = Math.max(0, totalFreeNeeded);
        
          // 🔁 Replace any last paid slot with a FREE one before adding more
          if (slotsToAdd > 0) {
            const paidSlots = this.optionalSlots.filter(slot => {
              const span = slot.element.querySelector('span');
              return span?.textContent !== 'FREE';
            });
        
            if (paidSlots.length > 0) {
              const lastPaidSlot = paidSlots[paidSlots.length - 1];
        
              // Change the slot label to FREE
              const span = lastPaidSlot.element.querySelector('span');
              span.textContent = 'FREE';
              span.className = 'text-white text-sm font-bold';
        
              // Mark it as free (no need to add a new one)
              return;
            }
          }
        
          // Otherwise, add new FREE slots if needed
          for (let i = 0; i < slotsToAdd; i++) {
            this.addOptionalSlot({ isFree: true });
          }
        }

        ensureEmptySlots() {
        if (!this.usesHaloPadLogic()) return;
          
          const totalFilled = this.items.slice(this.primarySlots).length;
          const totalSlots = this.optionalSlots.length;
          const emptySlots = totalSlots - totalFilled;
          
          // We want exactly 2 empty slots at all times
          const targetEmptySlots = 2;
          
          if (emptySlots < targetEmptySlots) {
            // Add slots to reach target
            const slotsToAdd = targetEmptySlots - emptySlots;
            for (let i = 0; i < slotsToAdd; i++) {
              this.addOptionalSlot();
            }
          } else if (emptySlots > targetEmptySlots) {
            // Remove excess empty slots from the end
            const slotsToRemove = emptySlots - targetEmptySlots;
            for (let i = 0; i < slotsToRemove; i++) {
              // Remove the last empty slot
              const lastEmptyIndex = this.optionalSlots.length - 1;
              const lastSlot = this.optionalSlots[lastEmptyIndex];
              if (lastSlot && !lastSlot.filled) {
                lastSlot.element.remove();
                this.optionalSlots.splice(lastEmptyIndex, 1);
              }
            }
          }
        }                           

        updateOptThumbs() {
          const thumbsContainer = this.querySelector('[data-opt-thumbs]');
          if (!thumbsContainer) return;
        
          thumbsContainer.innerHTML = '';
        
          const optionalItems = this.items.slice(this.primarySlots);
        
          optionalItems.forEach(item => {
            const img = document.createElement('img');
            img.src = item.image;
            img.alt = item.title;
            img.className = 'w-12 h-12 object-cover rounded border';
            thumbsContainer.appendChild(img);
          });
        }        

        add(event) {
          const button = event.currentTarget;
        
          const item = {
            id: button.dataset.id,
            title: button.dataset.title,
            image: button.dataset.image,
            price: button.dataset.price,
            selling_plan: this.selectedSellingPlan,
            subscription_text: this.selectedSellingPlan ? 'Subscription selected' : 'One-time purchase'
          };
        
          this.items.push(item);
        
        if (this.usesHaloPadLogic()) {
            const totalFilled = this.items.slice(this.primarySlots).length;

            // Hide placeholder when first optional product is added
            if (totalFilled === 1) {
              this.optionalSlotPlaceholder?.classList.add('hidden');
            }

            if (this.isInPromoRange()) {
              this.ensureFreeSlots();
            } else {
              // Ensure we always have at least 2 empty slots, but never more than 2
              this.ensureEmptySlots();
            }
          }
          
        
          scrollToElement(".bg-chirp-gray-neutral.shrink-0");
          this.updateUI();
        }                  

        addOptionalSlot({ isFree = false } = {}) {
          if (this.optionalSlots.length >= this.maxOptionalSlots) return;
        
          const newSlot = this.optionalSlotTemplate.content.cloneNode(true);
          const slotElement = newSlot.querySelector('[data-bb-optional-slot]');
        
          const index = this.optionalSlots.length;
          slotElement.dataset.slotIndex = index;
        
          if (isFree) {
            const span = slotElement.querySelector('span');
            span.textContent = 'FREE';
            span.className = 'text-white text-sm font-bold';
          }
        
          this.optionalSlotsContainer.appendChild(slotElement);
          this.optionalSlots.push({
            element: slotElement,
            filled: false,
            index
          });
        }        

        removeOptionalSlot(index) {
          const itemIndex = this.primarySlots + index;
          const removedItem = this.items[itemIndex];
        
          if (removedItem) {
            this.items.splice(itemIndex, 1);
          }
        
          if (removedItem?.id) {
            const optEl = this.querySelector(`[data-bb-opt-product="${removedItem.id}"]`);
            optEl?.removeAttribute('selected');
            optEl?.classList.remove('bg-chirp-gray');
          }
        
          const slotIndex = this.optionalSlots.findIndex(slot => {
            return slot.element.dataset.slotIndex == index;
          });
        
          if (slotIndex > -1) {
            this.optionalSlots[slotIndex].element.remove();
            this.optionalSlots.splice(slotIndex, 1);
          }
        
          this.optionalSlots.forEach((slot, i) => {
            slot.element.dataset.slotIndex = i;
            slot.index = i;
          });
        
          this.updateUI();
          this.updateOptionalProductPrices();
        
        if (this.usesHaloPadLogic()) {
            if (this.isInPromoRange()) {
              setTimeout(() => this.ensureFreeSlots(), 0);
            } else {
              setTimeout(() => this.ensureEmptySlots(), 0);
            }
          }
        }        
        
        // Cuenta cuántos slots marcados como FREE están actualmente llenos
        countFilledFreeSlots() {
          const optionalItems = this.items.slice(this.primarySlots);
          return optionalItems.length;
        }

        // Cuenta cuántos slots gratuitos VACÍOS hay
        countEmptyFreeSlots() {
          return this.optionalSlots.filter(slot => {
            const span = slot.element.querySelector('span');
            const isFree = span?.textContent === 'FREE';
            const itemIndex = this.optionalSlots.indexOf(slot);
            const item = this.items[this.primarySlots + itemIndex];
            return isFree && !item;
          }).length;
        }

        updateDiscountBanners() {
          const banner3 = this.querySelector('#discount-banner-3');
          const banner5 = this.querySelector('#discount-banner-5');
          
          if (!banner3 || !banner5) return;
          
          // Count optional items (pads added)
          const optionalItems = this.items.slice(this.primarySlots);
          const padCount = optionalItems.length;
          
          // Threshold values
          const threshold3 = 3;
          const threshold5 = 5;
          
          // Calculate remaining pads needed
          const remaining3 = Math.max(0, threshold3 - padCount);
          const remaining5 = Math.max(0, threshold5 - padCount);
          
          // Update 3-pad banner
          const remaining3Span = banner3.querySelector('[data-remaining]');
          if (remaining3Span) {
            remaining3Span.textContent = remaining3;
          }
          
          if (padCount >= threshold5) {
            // Hide 3-pad banner when 5-pad threshold is met
            banner3.classList.add('hidden');
          } else if (padCount >= threshold3) {
            // Show green congratulations message for 3-pad threshold
            banner3.classList.remove('hidden');
            banner3.classList.remove('bg-chirp-gray-lighter', 'text-chirp-blue-dark');
            banner3.classList.add('bg-chirp-green-light', 'text-chirp-blue-dark');
            banner3.innerHTML = "🎉 Congrats, you've unlocked <span class='font-bold'>15% off</span>";
          } else {
            // Show default state
            banner3.classList.remove('hidden');
            banner3.classList.remove('bg-chirp-green-light');
            banner3.classList.add('bg-chirp-gray-lighter', 'text-chirp-blue-dark');
            banner3.innerHTML = `Select <span class="font-bold" data-remaining>${remaining3}</span> more pads to receive <span class="font-bold">15% off</span> each pad`;
          }
          
          // Update 5-pad banner
          const remaining5Span = banner5.querySelector('[data-remaining]');
          if (remaining5Span) {
            remaining5Span.textContent = remaining5;
          }
          
          if (padCount >= threshold5) {
            // Show green congratulations message for 5-pad threshold
            banner5.classList.remove('bg-chirp-gray-lighter', 'text-chirp-blue-dark');
            banner5.classList.add('bg-chirp-green-light', 'text-chirp-blue-dark');
            banner5.innerHTML = "🎉 Congrats, you've unlocked <span class='font-bold'>20% off</span>";
          } else {
            // Show default state
            banner5.classList.remove('bg-chirp-green-light');
            banner5.classList.add('bg-chirp-gray-lighter', 'text-chirp-blue-dark');
            banner5.innerHTML = `Select <span class="font-bold" data-remaining>${remaining5}</span> more pads to receive <span class="font-bold">20% off</span> each pad`;
          }
        }

        setupDraggableScroll() {
          const container = this.optionalSlotsContainer;
          if (!container) return;

          let isDown = false;
          let startX;
          let scrollLeft;

          // Prevent image dragging
          container.addEventListener('dragstart', (e) => {
            e.preventDefault();
          });

          container.addEventListener('mousedown', (e) => {
            // Don't interfere with button clicks
            if (e.target.closest('button')) return;
            
            isDown = true;
            container.style.cursor = 'grabbing';
            container.style.userSelect = 'none';
            startX = e.pageX - container.offsetLeft;
            scrollLeft = container.scrollLeft;
          });

          container.addEventListener('mouseleave', () => {
            isDown = false;
            container.style.cursor = 'grab';
            container.style.userSelect = '';
          });

          container.addEventListener('mouseup', () => {
            isDown = false;
            container.style.cursor = 'grab';
            container.style.userSelect = '';
          });

          container.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - container.offsetLeft;
            const walk = (x - startX) * 2; // Multiply by 2 for faster scrolling
            container.scrollLeft = scrollLeft - walk;
          });

          // Set initial cursor
          container.style.cursor = 'grab';
        }

        // getSubscriptionPlanElement(variantId) {
        //     return this.querySelector(`subscription-box[data-variant-id="${variantId}"]`);
        // }


        // getSubscriptionPlan(variantId) {
        //   const subscriptionBox = this.querySelector(
        //     `subscription-box[data-variant-id="${variantId}"]`
        //   );
        //   return subscriptionBox ? subscriptionBox.querySelector("select").value : null;
        // }


        isValid() {
          // const totalRequiredSlots = this.primarySlots + this.minOptionalSlots; <-- this logic made it so the ATC button was disabled when the user had only selected the parent product. We've updated it to allow adding the parent product alone.
          // Only require primary slots to be filled (allow adding parent product alone)
          const totalRequiredSlots = this.primarySlots;

          // Count filled slots (non-empty items)
          const filledSlots = this.items.filter(item => item !== null && item !== undefined).length;

          return filledSlots >= totalRequiredSlots;
        }

        isHaloBundle() {
          return Boolean(this.querySelector('[data-bb-screen="0"]')?.dataset.haloBundle);
        }

        remove(event) {
            const index = parseInt(event.target.dataset.bbRemove) - 1;
            const baseSlots = this.primarySlots + this.secondarySlots;

            // If we have optional slots, shift items up instead of removing from middle
            if (this.optionalSlots.length > 0) {
                // Remove the last item and optional slot
                const lastOptionalSlot = this.optionalSlots.pop();
                if (lastOptionalSlot && lastOptionalSlot.element) {
                    lastOptionalSlot.element.remove();
                }
                this.items.splice(index, 1);
            } else {
                // Normal removal if no optional slots
                this.items.splice(index, 1);
            }

            this.updateUI();
            this.optionalSlotPlaceholder?.classList.remove('hidden');
            this.selectedOptionalOrder = [];
            this.updateOptionalProductPrices();
            
            // Ensure we maintain 2 empty slots after removal
        if (this.usesHaloPadLogic() && !this.isInPromoRange()) {
              setTimeout(() => this.ensureEmptySlots(), 0);
            }
        }

        updateUI() {
          this.updateSlots();
          this.updateOptionalSlots();
          this.toggleScreens();
          this.toggleAddToCartButton();
          this.updateSecondaryButtons();
          this.updateSelections();
          this.updateDiscountBanners();
          // this.setupDesktopCollapse();
        }

        updateOptionalSlots() {
          const startIndex = this.primarySlots;
        
          this.optionalSlots.forEach((slot, index) => {
            const itemIndex = startIndex + index;
            const item = this.items[itemIndex];
            const container = slot.element;
            const placeholderSpan = container.querySelector('[data-bb-image-container] span');
            const image = container.querySelector('[data-bb-image-container] img');
            const removeBtn = container.querySelector('[data-bb-remove-optional]');
        
            if (item) {
              // Marcar slot como lleno
              slot.filled = true;
        
              // Mostrar título y tipo de compra
              const titleContainer = container.querySelector('[data-slot-title]');
              if (titleContainer) {
                titleContainer.innerHTML = `
                  <span class="block font-bold">${item.title}</span>
                  <span class="block text-xs mt-1">${item.subscription_text}</span>
                `;
              }
        
              // Imagen, precio y estilo
              image.src = item.image;
              image.classList.remove('hidden');
              placeholderSpan.classList.add('hidden');
              container.querySelector('[data-bb-image-container]').classList.add('border-chirp-green-light');
        
              const priceElement = container.querySelector('[data-price]');
              if (priceElement) priceElement.textContent = item.price;
        
              removeBtn.classList.remove('hidden');
            } else {
              // Marcar slot como vacío
              slot.filled = false;
        
              const titleElement = container.querySelector('[data-slot-title]');
              if (titleElement) titleElement.textContent = `Pad`;
        
              const priceElement = container.querySelector('[data-price]');
              if (priceElement) priceElement.textContent = '';
        
              image.src = '';
              image.classList.add('hidden');
              placeholderSpan.classList.remove('hidden');
              container.querySelector('[data-bb-image-container]').classList.remove('border-chirp-green-light');
        
              removeBtn.classList.add('hidden');
            }
          });
        }        

        updateSlots() {
          this.slots.forEach((slot, idx) => {
            const item = this.items[idx];
            const removeBtn = slot.querySelector('[data-bb-remove]');
        
            if (item) {
              const titleElement = slot.querySelector('[data-slot-title]');
              if (titleElement) titleElement.textContent = item.title;
              slot.querySelector("[data-slot-image]").src = item.image;
              slot.querySelector("[data-bb-image-container]").classList.add("border-chirp-green-light");
        
              if (item.price) {
                const priceElement = slot.querySelector('[data-price]');
                if (priceElement) priceElement.textContent = item.price;
              } 
        
              // Show remove button
              removeBtn?.classList.remove("hidden");
            } else {
              const titleElement = slot.querySelector('[data-slot-title]');
              if (titleElement) titleElement.textContent = `Unit`;
              slot.querySelector("[data-slot-image]").src = "";
              slot.querySelector("[data-bb-image-container]").classList.remove("border-chirp-green-light");
        
              // Hide remove button
              removeBtn?.classList.add("hidden");
            }
          });
        }
        
        updateSecondaryButtons() {
          const secondaryButtons = this.querySelectorAll('[data-bb-screen="1"] [data-modal-activate]');
          const allSlotsFilled = this.items.length >= (this.primarySlots + this.optionalSlots.length);

          secondaryButtons.forEach(button => {
            if (allSlotsFilled) {
              button.setAttribute('disabled', 'disabled');
              button.classList.replace('btn-primary', 'btn-disabled');
            } else {
              button.removeAttribute('disabled');
              button.classList.replace('btn-disabled', 'btn-primary');
            }
          });
        }

        updateSelections() {
          // Build a Set of selected IDs for fast lookup
          const selectedIds = new Set(this.items.map(item => String(item.id)));
        
          // Update main product elements
          this.mainProductElements.forEach(el => {
            const id = el.dataset.bbMainProduct;
            if (selectedIds.has(id)) {
              el.setAttribute("selected", "");
              el.classList.add("is-selected");
            } else {
              el.removeAttribute("selected");
              el.classList.remove("is-selected");
            }
          });
        
          // Update optional product elements
          this.optProductElements.forEach(el => {
            const id = el.dataset.bbOptProduct;
            if (selectedIds.has(id)) {
              el.setAttribute("selected", "");
              el.classList.add("is-selected");
            } else {
              el.removeAttribute("selected");
              el.classList.remove("is-selected");
            }
          });
        }        

        toggleScreens() {
            const screen1 = this.querySelector("[data-bb-screen='1']");
            const screen0 = this.querySelector("[data-bb-screen='0']");

            if (this.items.length >= this.primarySlots) {
                toggleVisibility(screen1, false);
                toggleVisibility(screen0, true);
            } else {
                toggleVisibility(screen1, true);
                toggleVisibility(screen0, false);
            }
        }


        toggleAddToCartButton() {
          if (this.isValid()) {
            this.addToCartBtn.removeAttribute("disabled");
            this.addToCartBtn.classList.replace("btn-disabled", "btn-secondary");
          } else {
            this.addToCartBtn.setAttribute("disabled", "disabled");
            this.addToCartBtn.classList.replace("btn-secondary", "btn-disabled");
          }
        }

        clear() {
          this.items = [];

          // Clear primary slot price
          this.slots.forEach(slot => {
              const priceElement = slot.querySelector('[data-price]');
              if (priceElement) {
                priceElement.textContent = '';
              }
          });

          // Remove all optional slots
          this.optionalSlots.forEach(slot => {
            slot.element.remove();
          });
          this.optionalSlots = [];

          // Fallback: reinitialize the default slot if none exists
        if (this.usesHaloPadLogic() && this.isInPromoRange()) {
            this.ensureFreeSlots();
          } else {
            this.addOptionalSlot();
          }

          this.updateUI();
          this.updateOptionalProductPrices();
        }

        addToCart() {
          if (!this.isValid()) return;
        
          const bundleId = `${this.items.map((item) => item.id).join("-")}-${Date.now()}`;

          const isHalo = this.isHaloBundle();        
          const padCount = this.items.slice(this.primarySlots).length;
          const shouldAddPadFlag = isHalo && padCount >= 2;
        
          const items = this.items.map((item, index) => {
            const properties = {
              _chirp_bundle: bundleId
            };
        
            if (shouldAddPadFlag) {
              properties._two_or_more_pads = true;
            }

            return {
              id: item.id,
              quantity: 1,
              selling_plan: item.selling_plan,
              properties
            };
          });
        
          this.sendCartRequest(items);
        }        

        sendCartRequest(items) {
          fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ items }),
          })
            .then((response) => response.json())
            .then((result) => {
              // MAI Add to Cart Tracking for bundle items
              if (typeof MAI !== 'undefined' && result.items) {
                result.items.forEach(item => {
                  MAI.emit('addToCart', item.price / 100, item.price_currency || 'USD', item.quantity, {
                    productId: String(item.product_id),
                    productName: item.product_title,
                    productType: item.product_type,
                    productVendor: item.vendor,
                    variantId: String(item.variant_id),
                    variantName: item.variant_title
                  });
                });
              }

              document.getElementById("frame-main-cart").reload();
              document.getElementById("cart-link").click();
              this.clear();
              // Close the bundle builder after successful cart addition
              const activator = document.querySelector('bundle-builder-activator');
              if (activator && activator.close) {
                activator.close();
              }
            })
            .catch((error) => console.error("Error:", error));
        }
      }
    );
  }

  function toggleVisibility(elementOrSelector, hide) {
    const element =
      typeof elementOrSelector === "string"
        ? document.querySelector(elementOrSelector)
        : elementOrSelector;

    if (hide) {
      element.classList.add("hidden");
    } else {
      element.classList.remove("hidden");
    }
  }

  function scrollToElement(selector) {
    const element = document.querySelector(selector);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      
      // Ensure body overflow stays hidden after scroll (mobile fix)
      if (document.querySelector('bundle-builder:not(.hidden)')) {
        document.body.style.overflow = 'hidden';
      }
    }
  }
